import React from "react";
import { Route, Routes } from "react-router-dom";
import CreateAgentsTeamStepper from "./CreateAgentsTeamStepper";
import AgentsTreePage from "./AgentsTree/AgentsTreePage";
import Team from "./Team/Team";

const AgentsTeamPage = () => {
  return (
    <Routes>
        <Route index element={<CreateAgentsTeamStepper />} />
        <Route path="tree" element={<AgentsTreePage />} />
        <Route path="new" element={<CreateAgentsTeamStepper />} />
        <Route path="team" element={<Team />} />
    </Routes>
  );
};

export default AgentsTeamPage;
